import { Injectable } from '@angular/core';
import { Avis } from '../../../../models/avis';
import { FormsEnum } from '../../../../models/enums/forms.enum';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { LogService } from '../../../shared/services/log.service';
import { Annonce } from '../../common/models/annonce';
import { TypeAnn } from '../../common/models/type.ann';
import { ADAPTE } from '../models/adapte';
import { FormADService } from './form-ad.service';

@Injectable({
	providedIn: 'root',
})
export class FormADExtractorService {

	private LOG: LogService = new LogService(FormADExtractorService);

	constructor(private formADService: FormADService) { }

	public mapFormToAvis(form,actualFormIdAnnEmetteur): Avis {
		const controls = this.formADService.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
		const formAD = new ADAPTE();
		formAD.facturation = this.formADService.facturationService.getFacturation(form, '', controls);
		formAD.logo = controls.get('_SepSep_formAD_SepAtt_logo');
		formAD.textArea = btoa(encodeURI(controls.get('_SepSep_formAD_SepAtt_TextArea')));
		const annonce = new Annonce();
		annonce.ann = new TypeAnn();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
		annonce.ann.indexation = null;
		annonce.ann.divers = null;
		annonce.ann.fnSimple = null;
		annonce.ann.mapa = null;
		annonce.ann.formAD = formAD;

		annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		
		const avis: Avis = new Avis();
		avis.jsonSaisieFormulaire = annonce;
		avis.formulaire.code = FormsEnum[FormsEnum.FORM_AD];
		avis.statut = StatutAvisEnum.ELABORE;
		return avis;
	}


}
